import { Box, Grid, Typography, Select, MenuItem } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { IoMdAdd } from "react-icons/io";
import React from "react";

const RATING_VALUES = {
  GOOD: "Grüne Karte",
  BAD: "Rote Karte"
};

const UsersCard = ({
  firstName = "",
  lastName,
  email,
  phoneNumber,
  address,
  isBadUser,
  numberOfReservations,
  isEditable = false,
  handleChangeRating,
  onClick,
}) => {
  return (
    <Box>
      <Box
        sx={{
          mt: 3,
          bgcolor: "white",
          py: 6,
          px: 6,
          borderRadius: "8px",
        }}
      >
        <Grid container spacing={6}>
          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography
              sx={{
                fontFamily: "Noto Sans JP",
                color: "#CD9D41",
                fontSize: "20px",
              }}
            >
              Name:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {firstName}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography
              sx={{
                fontFamily: "Noto Sans JP",
                color: "#CD9D41",
                fontSize: "20px",
              }}
            >
              Nachname:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {lastName}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography
              sx={{
                color: "#CD9D41",
                fontFamily: "Noto Sans JP",
                fontSize: "20px",
              }}
            >
              E-Mail:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {email}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography
              sx={{
                color: "#CD9D41",
                fontFamily: "Noto Sans JP",
                fontSize: "20px",
              }}
            >
            Telefonnummer
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {phoneNumber}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography
              sx={{
                color: "#CD9D41",
                fontFamily: "Noto Sans JP",
                fontSize: "20px",
              }}
            >
              Adresse:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {address}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography
              sx={{
                color: "#CD9D41",
                fontFamily: "Noto Sans JP",
                fontSize: "20px",
              }}
            >
              Bewertung:
            </Typography>
            
            {isEditable ? (
              <Select
                value={isBadUser}
                onChange={handleChangeRating}
                size="small"
                sx={{
                  bgcolor: isBadUser === RATING_VALUES.BAD ? "#C03C3C38" : "#36D06A38",
                  borderRadius: "14px",
                  px: 2,
                  minWidth: 125,
                }}
                name="isBadUser"
              >
                <MenuItem value={RATING_VALUES.GOOD}>{RATING_VALUES.GOOD}</MenuItem>
                <MenuItem value={RATING_VALUES.BAD}>{RATING_VALUES.BAD}</MenuItem>
              </Select>
            ) : (
              <Box
                sx={{
                  px: 6,
                  py: "7px",
                  borderRadius: "14px",
                  bgcolor: isBadUser === RATING_VALUES.BAD ? "#C03C3C38" : "#36D06A38",
                  border: isBadUser === RATING_VALUES.BAD
                    ? "3px solid #C03C3C38"
                    : "3px solid #36D06A38",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "16px",
                    color: isBadUser === RATING_VALUES.BAD ? "#C03C3C" : "#36D06A",
                  }}
                >
                  {isBadUser}
                </Typography>
              </Box>
            )}
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography
              sx={{
                color: "#CD9D41",
                fontFamily: "Noto Sans JP",
                fontSize: "20px",
              }}
            >
              Anzahl der Buchungen:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {numberOfReservations}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography
              sx={{
                color: "#CD9D41",
                fontFamily: "Noto Sans JP",
                fontSize: "20px",
              }}
            >
              Admin-Notiz
            </Typography>
            <IconButton onClick={onClick}>
              <IoMdAdd color="#36D06A" style={{ zIndex: "100px" }} />
            </IconButton>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default UsersCard;